import { NavLink, Outlet, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const TABS = [
  { to: "/admin/shows", label: "shows", testid: "admin-tab-shows" },
  { to: "/admin/import", label: "import", testid: "admin-tab-import" },
  { to: "/admin/upkeep", label: "upkeep", testid: "admin-tab-upkeep" },
  { to: "/admin/credits", label: "credits", testid: "admin-tab-credits" },
  { to: "/admin/invites", label: "invites", testid: "admin-tab-invites" },
  { to: "/admin/reports", label: "reports", testid: "admin-tab-reports" },
];

export default function AdminLayout() {
  const { user } = useAuth();
  return (
    <main data-testid="admin-area" className="min-h-screen bg-black text-white pb-28">
      <header className="px-5 pt-6 pb-3 border-b-2 border-white/15">
        <Link
          to="/home"
          className="font-mono text-xs lowercase text-white/60 hover:text-white inline-flex items-center gap-1.5"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> back
        </Link>
        <div className="flex items-baseline justify-between mt-2">
          <h1 className="font-display text-4xl sm:text-5xl leading-none">
            admin<span className="text-acid">.</span>
          </h1>
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-acid">
            {user?.username}
          </div>
        </div>
      </header>

      <nav className="border-b-2 border-white/15 overflow-x-auto no-scrollbar">
        <ul className="flex whitespace-nowrap">
          {TABS.map((t) => (
            <li key={t.to}>
              <NavLink
                to={t.to}
                data-testid={t.testid}
                className={({ isActive }) =>
                  `block px-5 py-3 font-mono text-[11px] uppercase tracking-wider border-r border-white/15 transition-colors ${
                    isActive
                      ? "bg-acid text-black"
                      : "text-white/70 hover:text-white hover:bg-white/5"
                  }`
                }
              >
                {t.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <Outlet />
    </main>
  );
}
